<template>
  <ExpenseFeeModalSectionFiles
    :active="active"
    :form="form"
    :entity-label="text.sections.sharedFiles.entityLabel"
    :text="text.sections.sharedFiles"
    :show-purchase-order="true"
  />
</template>

<script>
import ExpenseFeeModalSectionFiles from '@/components/expensesFees/modal/ExpenseFeeModalSections/ExpenseFeeModalSectionFiles.vue';
import { useDomainText } from '@/composables/text/useDomainText';

const { catalog: text } = useDomainText('expenses');

export default {
  name: 'ExpenseModalSectionFiles',
  components: {
    ExpenseFeeModalSectionFiles,
  },
  data() {
    return {
      text,
    };
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      required: true,
    },
  },
};
</script>
